var React = require('react');

function Linked (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-x1{fill:#bcbcbc;fill-rule:evenodd;}")),React.createElement("g",{"id":"Ebene_2","data-name":"Ebene 2","key":1},React.createElement("g",{"id":"Text"},React.createElement("path",{"className":"cls-x1","d":"M8.61,0a8.61,8.61,0,1,0,8.61,8.61A8.62,8.62,0,0,0,8.61,0ZM4.13,7.13h2V13h-2ZM6.21,5.32a1,1,0,0,0-1.09-1,1,1,0,1,0,0,2h0A1,1,0,0,0,6.21,5.32ZM10.88,7c1.28,0,2.24.83,2.24,2.63V13H11.17V9.86c0-.79-.28-1.33-1-1.33a1.07,1.07,0,0,0-1,.72,1.34,1.34,0,0,0-.06.47V13H7.17s0-5.32,0-5.87H9.12V8A1.93,1.93,0,0,1,10.88,7Z"})))]);
}

Linked.defaultProps = {"viewBox":"0 0 17.22 17.22"};

module.exports = Linked;

Linked.default = Linked;
